import { useCommonWidgetHandlers } from './use-common-widget-handlers';
import * as Widgets from '@mm/constants/widgets';

export const useGifWidgetHandlers = () => {
  const commonWidgetHandlers = useCommonWidgetHandlers();

  const addNew = (dialogueId: number, sortOrder: number) => {
    const newWidget = {
      pageId: dialogueId,
      type: Widgets.GIF,
      label: '',
      sortOrder,
      config: {
        title: 'Search Gif',
        assetId: null,
      },
    };

    return commonWidgetHandlers.create(newWidget, dialogueId, sortOrder);
  };

  return {
    delete: commonWidgetHandlers.delete,
    addNew,
  };
};
